import kiknetIcon from "../../embedded/kiknet.webp";
import knetIcon from "../../embedded/knet.webp";
import hx from "../utils/hydroxie";
import { ContentControl } from "../utils/maputil/legendcontrol";

/**
 * 観測点の凡例
 */
export class StationLegendControl extends ContentControl {
    /**
     * コンストラクター。
     */
    constructor() {
        const content = hx("div", { className: "ol-station-legend-control-content" });
        const style = {
            bottom: "2.5em",
            right: "0.5em",
        };

        super({ content, style });

        const df = hx("",
            hx("div",
                hx("img", { src: knetIcon })),
            hx("div", "K-NET"),
            hx("div",
                hx("img", { src: kiknetIcon })),
            hx("div", "KiK-net"));

        content.replaceChildren(df);
    }
}
